import React from "react";
// import { useState } from "react";
import { useTranslation } from "react-i18next";

// import { Trans } from "react-i18next";

function EventsPage() {
  const { t } = useTranslation();

  const webinars = [
    {
      key: 0,
      label: "Hot Release",
      date: "26 Jan 2021",
      title: "Sintel",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      videoUrl:
        `${process.env.REACT_APP_SMIK_API_BASEURL}/webinars/trailer_hd.mp4`,
      videoType: "video/mp4",
      posterUrl: "https://video-react.js.org/assets/poster.png",
      link: "https://www.niagarathisweek.com/opinion-story/10390213-india-s-terrible-pandemic-grief-is-your-long-term-loss/",
      source: "Niagara this Week",
    },
    {
      key: 1,
      date: "7 Jan 2021",
      title: "Space Jam - A new Legacy",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      videoUrl:
      `${process.env.REACT_APP_SMIK_API_BASEURL}/webinars/spaceJamhd.mov`,
      image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/artImage2.webp`,
      link: "https://www.thespec.com/opinion/contributors/2021/01/07/getting-online-education-right-ideas-for-a-better-second-semester.html",
      source: "The Hamilton Spectator",
    },
    {
      key: 2,
      date: "13 Jun 2020",
      title: "Boss Baby Family Business",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      videoUrl:
        `${process.env.REACT_APP_SMIK_API_BASEURL}/webinars/bossBaby_hd.mov`,
      image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/artImage3.webp`,
      link: "https://www.b2bnn.com/2021/01/the-opportunity-to-co-invent-an-invitation-to-learning-and-development-professionals/",
      source: "B2B News Network",
    },
    {
      key: 3,
      title: "Crazy Rich Asians",
      date: "10 June 2021",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      videoUrl:
        "http://movietrailers.apple.com/movies/wb/crazy-rich-asians/crazy-rich-asians-trailer-1_h1080p.mov",
      image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
      link: "https://www.newsfilecorp.com/release/87222/Renowned-Conservationist-Matthew-Richardson-to-Teach-Kids-to-Protect-Endangered-Species-with-smiklearn",
      source: "Newsfile",
    },
    {
      key: 4,
      label: "Hot Release",
      date: "10 June 2021",
      title: "Alpha",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      text: "yslearn Enters Partnership with Master Coach & Accumatch Founder Nagui Bihelek",
      videoUrl:
        "http://movietrailers.apple.com/movies/sony_pictures/alpha/alpha-trailer-2_h1080p.mov",
      image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
      link: "https://www.newsfilecorp.com/release/87220/smiklearn-Enters-Partnership-with-Master-Coach-Accumatch-Founder-Nagui-Bihelek",
      source: "Newsfile",
    },
    {
      key: 5,
      label: "Hot Release",
      date: "06 Apr 2021",
      title: "Out of Death",
      desc: "The poster attribute specifies an image to be shown while the video is downloading, or until the user hits the play button. If this is not included, the first frame of the video will be used instead.",
      videoUrl:
        "https://movietrailers.apple.com/movies/independent/out-of-death/out-of-death-trailer-1_h1080p.mov",
      image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
      link: "https://www.newsfilecorp.com/release/79571/smiklearn-Partners-with-AI-Expert-Brian-Lenahan-to-Offer-Business-Leaders-Crucial-Learning-Opportunity",
      source: "Newsfile",
    },
  ];

  return (
    <div className="InternalPage">
      <section className="InternalHead">
        <div className="internal-text">
          <h1 className="center">{t("Webinars & Events")}</h1>
        </div>
      </section>

      <section className="InternalBody">
        <div className="press-wrapper">
          <div className="page-title">Events 2021 [Experimental]</div>
          <div className="press-inner-wrapper">
            {webinars.map((item) => {
              return (
                <article className="press-item" key={item.key}>
                  <div className="video-wrapper">
                    {/*<span className='video-play-icon'></span>*/}
                    <span className="featured-video-label">Featured</span>
                    <video
                      width="342"
                      height="220"
                      controls
                      poster={item.posterUrl}
                    >
                      <source src={item.videoUrl} type={item.videoType} />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div className="content-wrapper">
                    {/*
                                            <div className='date'>
                                                {item.date}
                                                <span className='press-label'>{item.label}</span>
                                            </div>
                                            */}

                    <div className="article-title">
                      {item.title}{" "}
                      <span className="press-label">{item.label}</span>
                    </div>

                    <div className="article-desc">{item.desc}</div>

                    <div className="source-link">
                      In {item.source}
                      {/*
                                                    <i className="logo-B2BNewsNetwork" />
                                                */}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default EventsPage;
